var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link scrollactive-item",attrs:{"href":("/#" + (_vm.header_menu.url))}},[_vm._v(" "+_vm._s(_vm.header_menu.title_az)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }